import { distinctUntilChanged } from 'rxjs';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, DestroyRef, EventEmitter, Input, Output } from '@angular/core';
import type { OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { type AbstractControl, ControlContainer, FormGroupDirective } from '@angular/forms';
import type { SelectButtonChangeEvent } from "primeng/selectbutton";
import * as FlatModels from '@medsurf/flat-models';

@Component({
    selector: 'medsurf-design-form-control-input-theme-color-select-button',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './theme-color-select-button.input.form-control.design.html',
    styleUrls: ['./theme-color-select-button.input.form-control.design.scss'],
    viewProviders: [
        {
            provide: ControlContainer,
            useExisting: FormGroupDirective
        }
    ],
    standalone: false
})
export class ThemeColorSelectButtonInputFormControlDesign implements OnInit, OnChanges {
  @Input() formField = true;
  @Input({ required: true }) control!: AbstractControl;
  @Input() label?: string;
  @Input() disabled = false;
  @Output() valueChange = new EventEmitter<SelectButtonChangeEvent>();
  
  readonly FlatModels = FlatModels;

  name?: string;

  constructor(private cd: ChangeDetectorRef, private destroyRef: DestroyRef) {
  }

  ngOnInit() {
    const formGroup = this.control.parent;
    this.name = formGroup ? Object.keys(formGroup.controls).find(name => this.control === formGroup.get(name)) : undefined;

    this.control?.statusChanges.pipe(takeUntilDestroyed(this.destroyRef), distinctUntilChanged()).subscribe(() => {
      this.cd.markForCheck();
    });

    if (this.name === undefined) {
      throw new FlatModels.ErrorControlModels.MedsurfError(
        'notification.form_control_name_not_found',
        FlatModels.ErrorControlModels.ErrorLevel.enum.error,
        FlatModels.ErrorControlModels.ErrorInstance.enum.AUTHOR,
        "LIBS.FlatDesign.ThemeColorSelectButtonInputFormControlDesign.ngOnInit"
      );
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['disabled']?.currentValue) {
      this.control?.disable();
    } else {
      this.control?.enable();
    }
  }
}
